import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { TaggableResourceList } from 'src/app/data/model/taggable-resource-list';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule
})
export class TaggableResourcePickupListApiService extends CrudApiService<TaggableResourceList> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('moda/taggable-resource-list', http, config);
  }
}